import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {HttpClientModule} from '@angular/common/http';
import {ConfiguratorModule} from './modules/configurator/configurator.module';
import {BaseModule} from './modules/base/base.module';
import {HomePageComponent} from './pages/home-page/home-page.component';
import {ConfiguratorPageComponent} from './pages/configurator-page/configurator-page.component';
import {PatternsModule} from './modules/patterns/patterns.module';
import {IonicStorageModule} from '@ionic/storage';
import {SaveConfigurationPageComponent} from './pages/save-configuration-page/save-configuration-page.component';
import {ProfilePageComponent} from './pages/profile-page/profile-page.component';
import {ProjectDetailsPageComponent} from './pages/project-details-page/project-details-page.component';
import {DecorationModule} from './modules/decoration/decoration.module';
import {HomePageModule} from './pages/home-page/home-page.module';
import {ProfilePageModule} from './pages/profile-page/profile-page.module';
import {PatternDetailsPageModule} from './pages/pattern-details/pattern-details.module';
import {InspirationPage} from './pages/inspiration/inspiration.page';
import {FabricsPage} from './pages/fabrics/fabrics.page';
import {FabricDetailsPage} from './pages/fabric-details/fabric-details.page';
import {FabricsModule} from './modules/fabrics/fabrics.module';
import {CookiesPageModule} from './pages/cookies/cookies.module';

@NgModule({
    declarations: [
        AppComponent,
        ConfiguratorPageComponent,
        SaveConfigurationPageComponent,
        ProjectDetailsPageComponent,
        InspirationPage,
        FabricsPage,
        FabricDetailsPage
    ],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            scrollAssist: true,
        }),
        HttpClientModule,
        BaseModule,
        ConfiguratorModule,
        PatternsModule,
        FabricsModule,
        DecorationModule,
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        HomePageModule,
        ProfilePageModule,
        PatternDetailsPageModule,
        CookiesPageModule,
        IonicStorageModule.forRoot({
            driverOrder: ['sqlite', 'indexeddb', 'websql', 'localstorage']
        })
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
